import React, { useState, useEffect, useContext } from 'react';
import { Row, Col } from 'react-bootstrap'
import Get from '../../api/Get'
import Post from '../../api/Post'
import { RELIGIONES_ALL, RELIGIONES_UPDATE } from "../../api/Routes";
import { RELIGIONES_ADD } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import ReligionList from './religion/ReligionList'
import AddReligion from './religion/AddReligion'
import Filtro from '../../components/catalogos/Filtro';
import LoadingList from "../../loader/LoadingList";

import '../../styles/catalogos/catalogos.css'
import { toBool } from '../../utils/toBool';
import Put from '../../api/Put';
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever';

function ReligionIndex(){

    //Parametros para actualizar la tabla
    const [items, setItems] = useState([])
    const [initialValues, setInitialValues] = useState({name:''})
    const [loading, setLoading] = useState(false)
    const [showModalServer, setShowModalServer] = useState(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
    }
    const [errorServer, setErrorServer] = useState(null)

    useEffect(() => cargarReligiones(), [])

    const cargarReligiones = () => {
        setLoading(true)
        Get({url: RELIGIONES_ALL, access_token: auth.data.access_token})
        .then((resp) => {
            setItems(resp.data.data.response.content)
            setLoading(false)
            
        })
        .catch((error) => {
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }

    const agregarReligion = (values) => {
        values.active = true;
        values.companies = [auth.data.company]
        setLoading(true)
        Post({url: RELIGIONES_ADD, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            console.log(response)
            setItems(prev=>[...prev, response.data])
            setInitialValues({name:''})            
            setLoading(false)
        })                
        .catch((error) => {
            console.log("Error encontrado", error)
            setShowModalServer(true)
            setErrorServer(error?.response)
            setLoading(false) 
        })
    }

    const editarReligion = (values) =>{

        if(toBool(values.active)){
            values.companies.push(auth.data.company)
        }else{
            let arr = values.companies.filter(el => el.id !== auth.data.company.id)
            values.companies = arr
        }
        Put({url: RELIGIONES_UPDATE, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            //ok     
        })                
        .catch((error) => {
            setLoading(false)     
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return(<>
        {loading && <LoadingList texto='' />}

        <div className="body">
            <Filtro catName ='Religiones'/>
            <Row>
                <Col xs="6" md="6">
                    {!loading && <AddReligion agregarReligion={agregarReligion} initialValues={initialValues} />}
                </Col>
                <Col xs="6" md="6">
                    <ReligionList items={items} 
                        editarReligion={editarReligion}
                        auth={auth}
                    />
                </Col>
            </Row>
        </div>

        <ComponentModalErrorSever
            show={showModalServer}
            handleClose={handleCloseModalServer}
            error={errorServer}
        />
    </>)
}

export default ReligionIndex